module.exports = __webpack_public_path__ + "static/media/sgd-9.353d85e7.png";